<template>
    <v-tabs 
        vertical
    >
        <v-tab
            class="tab"
            v-for="item in itemsTabs"
            :key="item.key"
            @click="getClickAba(item.key)"
        >
            {{ item.label }}
        </v-tab>

        <v-tab-item
            class="p-1"
            v-for="item in itemsTabs"
            :key="item.key"
        >
            <div class="p-4 mt-2">
                <SGPDynamicImportComponent 
                    :pathFile="item.pathComponent" 
                    :ref="item.key"
                />
            </div>
        </v-tab-item>
    </v-tabs>    
</template>

<script>
export default {
    name: 'SGPTabsMenuVerticalComponent',            
    props: { 
        itemsTabs : {
            type: Array,
            required: true
        },        
        value: {
            type: Object,
            required: false
        }    
    },    

    updated () {
        this.montaPagina()        
    },

    created () {        
        this.montaPagina()            
    },

    methods: {
        montaPagina () {
            if (typeof(this.value.itemsVertical) !== 'undefined') {
                this.itemsTabs = this.value.itemsVertical            
            }        
        },
        getClickAba (abaKey) {
            if (typeof(this.$refs[abaKey]) !== 'undefined' && 
                typeof(this.$refs[abaKey][0].$children) !== 'undefined' &&
                typeof(this.$refs[abaKey][0].$children[0].updateList) === 'function'
            ) {
                    this.$refs[abaKey][0].$children[0].updateList()                
            } 
        }
    }
}
</script>

<style>
.v-slide-group__wrapper {
    border-bottom: 0px;
}

.tab {
    justify-content: left !important;
    border-bottom: 1px solid #0000001c;
}

/*
.v-tabs--vertical {
    align-items: start;
    flex-direction: column;
    text-align: left;
  }
*/
</style>